import { Data } from './../../models/CoinSnapshot';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NewsResponse, News, FeedsAndCategoriesResponse, FeedsAndCategories, Feed, Category } from '../../models/News'
import { InAppBrowser } from '@ionic-native/in-app-browser';

@Injectable()
export class NewsProvider {

  feeds: Feed[];
  categories: Category[];
  sortOrder: string = 'latest';
  singleCategory: Category = null;
  singleFeed: Feed = null;

  feedsLoaded: boolean = false;
  constructor(public http: HttpClient, private iab: InAppBrowser) {
    this.getFeedsAndCategories().subscribe(data =>{
      //Set
      this.feeds = data.Feeds;
      this.categories = data.Categories;

      //Sort
      this.feeds.sort((a, b) => {
        return a.name.localeCompare(b.name);
      })

      this.categories.sort((a, b) => {
        return a.categoryName.localeCompare(b.categoryName);
      })

      //Set enabled for feeds
      this.setAllFeeds(true);
      this.setAllCategories(true);
      this.feedsLoaded = true;
    })
  }

  getAllNews(): Observable<News[]>{
    return this.http.get('https://min-api.cryptocompare.com/data/v2/news/?lang=EN')
      .map((response: any) => {
        return response.Data;
      })
  }

  getFeedsAndCategories(): Observable<FeedsAndCategories>{
    return this.http.get('https://min-api.cryptocompare.com/data/news/feedsandcategories')
      .map((response: FeedsAndCategoriesResponse) => {
        return response.Data;
      }).share();
  }

  getNewsWithOptions(): Observable<News[]>{
    const url = `https://min-api.cryptocompare.com/data/v2/news/?lang=EN&feeds=${this.getFeedsEncoded()}&sortOrder=${this.sortOrder}`;
    return this.http.get(url)
      .map((response: NewsResponse) => {
        return response.Data;
      }, error => {
      })
  }

  getNewsForCategory(category: Category): Observable<News[]>{
    const url = `https://min-api.cryptocompare.com/data/v2/news/?lang=EN&feeds=${this.getFeedsEncoded()}&sortOrder=${this.sortOrder}&categories=${category.categoryName}`;
    return this.http.get(url)
      .map((response: NewsResponse) => {
        return response.Data;
      })
  }

  getNewsForFeed(feed: Feed): Observable<News[]>{
    const url = `https://min-api.cryptocompare.com/data/v2/news/?lang=EN&feeds=${feed.key}&sortOrder=${this.sortOrder}`;
    return this.http.get(url)
      .map((response: NewsResponse) => {
        return response.Data;
      })
  }



  openLink(news: News){
    let browser = this.iab.create(news.url);
    browser.show();
  }

  setAllFeeds(enable: boolean){
    if(this.feeds){
      for(let feed of this.feeds){
        feed.enabled = enable;
      }
    }
  }

  setAllCategories(enable: boolean){
    if(this.categories){
      for(let category of this.categories){
        category.enabled = enable;
      }
    }
  }

  public feedsAreDeselected(): boolean{
    return (this.feeds.length != this.feeds.filter(feed => feed.enabled).length);
  }

  private getFeedsEncoded(): string{
    let feeds = '';
    if(this.feeds){
      feeds = this.feeds.filter(val => val.enabled).map(val => val.key).join(',');
    }
    if(feeds.length > 400) feeds = feeds.slice(0, 400);
    return feeds;
  }



  private getCategoriesEncoded(): string{
    let categories = '';
    if(this.feeds){
      categories = this.categories.filter(val => val.enabled).map(val => val.categoryName).join(',');
    }
    return categories;
  }

}



// WEBPACK FOOTER //
// ./src/providers/news/news.ts